import { FilterValues } from "../../../../data-model/filterValues";
import {
  processFilterData,
  transformDateFields,
  transformObjectToKeyValueArray,
} from "../../../../utils/queryConstraint";

export const generateFilterPayloadForMyPaOrders = (
  validFilters: FilterValues[],
  searchTerm: string,
  orgId: string,
  userId: string,
) => {
  const filterData = processFilterData(validFilters);
  const preComputedFilterData = {
    ...filterData,
    assigned_to: [userId],
    master_auth_status: ["new"],
  };

  const createdFilterQuery = transformObjectToKeyValueArray(
    preComputedFilterData,
  ).map((item) => item);

  const dateFilterQuery = transformDateFields(preComputedFilterData);
  const payload = {
    org_id: orgId || "",
    query: searchTerm ?? "",
    facet_filters: createdFilterQuery,
    hits_per_page: 400,
    page: 0,
    ...dateFilterQuery,
  };
  return payload;
};
